import { WidgetPlugin } from '@/common/enums';
import { PluginConfig } from '@/lib/types/tenant';

import type { AccessibilityPluginAdapter } from './types';

export { A11Y_CONSTANTS } from './constants';
export { USERWAY_CONSTANTS } from './userway-constants';
export type { AccessibilityPluginAdapter, AccessibilityState } from './types';

const ACCESSIBILITY_PLUGINS: Record<string, () => Promise<AccessibilityPluginAdapter>> = {
  [WidgetPlugin.NagichAccessibility]: () =>
    import('./accessibility-adapter').then(m =>
      m.createAccessibilityAdapter(WidgetPlugin.NagichAccessibility),
    ),
  [WidgetPlugin.UserWayAccessibility]: () =>
    import('./accessibility-adapter').then(m =>
      m.createAccessibilityAdapter(WidgetPlugin.UserWayAccessibility),
    ),
};

export async function getAccessibilityAdapter(
  plugin: WidgetPlugin,
): Promise<AccessibilityPluginAdapter | null> {
  const factory = ACCESSIBILITY_PLUGINS[plugin];
  return factory?.() ?? null;
}

export function findAccessibilityPlugin(plugins?: PluginConfig[]): WidgetPlugin | null {
  if (plugins?.some(p => p.plugin === WidgetPlugin.NagichAccessibility)) {
    return WidgetPlugin.NagichAccessibility;
  }
  if (plugins?.some(p => p.plugin === WidgetPlugin.UserWayAccessibility)) {
    return WidgetPlugin.UserWayAccessibility;
  }
  return null;
}
